import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Increase: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9864 6.17965C15.1843 5.66405 15.7627 5.4065 16.2783 5.60441L22.2183 7.88441C22.7339 8.08231 22.9915 8.6607 22.7936 9.17629L20.5136 15.1173C20.3157 15.6329 19.7373 15.8905 19.2217 15.6926C18.7061 15.4947 18.4485 14.9163 18.6464 14.4007L20.0615 10.7135L19.5268 10.9515L19.5253 10.9522C17.2202 11.9742 15.3384 13.7605 14.1978 16.0093C14.0529 16.2951 13.7798 16.4941 13.4633 16.5446C13.1468 16.595 12.8254 16.4906 12.5988 16.264L8.99992 12.6643L2.95711 18.7071C2.56658 19.0976 1.93342 19.0976 1.54289 18.7071C1.15237 18.3166 1.15237 17.6834 1.54289 17.2929L8.29289 10.5429C8.48044 10.3553 8.73482 10.25 9.00006 10.25C9.2653 10.25 9.51966 10.3554 9.70719 10.543L13.091 13.9275C14.4532 11.8222 16.4037 10.1487 18.7137 9.12424C18.7141 9.1241 18.7144 9.12396 18.7147 9.12383L19.2478 8.88646L15.5617 7.47159C15.046 7.27368 14.7885 6.69526 14.9864 6.17965Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Increase;
